

<template>
    <enroll-prime-dashboard v-if="!displayItems"/>
    <neura-dashboard v-else/>
    </template>
    <script>
    import {restrictedReps} from "@/utils/constant";
    
    import EnrollPrimeDashboard from "./EnrollPrimeDashboard.vue";
    import NeuraDashboard from "./NeuraDashboard.vue";
    export default{
        components:{
            EnrollPrimeDashboard, 
            NeuraDashboard
        },
       computed:{
        repCode() {
          return this.$store.getters.repId;
        },
        displayItems() {
          if (restrictedReps.includes(this.repCode)) {
            return false;
          }
          return true;
        }
       } 
    }
    </script>